import React from 'react';
import FeedbackCriteria from 'components/FeedbackCriteria/FeedbackCriteria';
import AddCriteria from 'components/FeedbackCriteria/AddCriteria';

const FeedbackCriteriaSection = ({
  canUseCustomFeedbackCriteria,
  feedbackCriteria,
  updateFeedbackCriteria,
}) => {
  if (feedbackCriteria.length > 0) {
    return (
      <FeedbackCriteria
        selectedCriteria={feedbackCriteria}
        handleUpdate={updateFeedbackCriteria}
        canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
      />
    );
  }

  return (
    <AddCriteria
      handleUpdate={updateFeedbackCriteria}
      canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
      description={t('feedback_criteria.practice_feedback_description')}
    />
  );
};

export default FeedbackCriteriaSection;
